/*  MUI  */
import {
    FileDownload,
    FolderOpenOutlined,
    FolderOutlined,
    FolderZipOutlined,
    ImageOutlined,
    PictureAsPdfOutlined
} from '@mui/icons-material';
import { Box, Button, CircularProgress, Paper } from '@mui/material';

/*  Shared  */
import { PageTitle } from 'application/Shared/Components/App';
import {
    Filter,
    TableFile,
    TableFolder,
    TableHeader
} from 'application/Shared/Components/FileBrowser';
import { URLs } from 'application/Shared/Constants';

/* Hooks */
import { useFetchSalesDocs } from 'hooks/dataAccess/SalesDocs/salesDocs';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import FileBrowser, { Icons } from 'react-keyed-file-browser';

const RenderDownloadAll = () => {
    const { t } = useTranslation();

    const allFilesUrl = `${URLs.salesDocs}/salesDocs/All Files.zip`;

    return (
        <Box>
            <Button
                data-testid="salesDocs-downloadAll"
                data-trackid="partner_salesDocs_downloadAll"
                variant="outlined"
                size="small"
                color="primary"
                href={allFilesUrl}
            >
                <FileDownload fontSize="small" style={{ marginRight: '8px' }} />
                {t('SalesDocs.download_all')}
            </Button>
        </Box>
    );
};

export const SalesDocs = () => {
    const { t } = useTranslation();
    const { files, loading } = useFetchSalesDocs();

    return (
        <>
            <PageTitle title={t('SalesHub.title')} />
            <Paper elevation={0} variant="outlined">
                {loading ? (
                    <Box p="16px" display="flex" justifyContent="center">
                        <CircularProgress size="32px" />
                    </Box>
                ) : (
                    <Box p="8px">
                        <FileBrowser
                            files={files}
                            icons={{
                                ...Icons.FontAwesome(4),
                                Archive: <FolderZipOutlined fontSize="small" />,
                                Download: <FileDownload fontSize="small" />,
                                Folder: <FolderOutlined fontSize="small" />,
                                FolderOpen: (
                                    <FolderOpenOutlined fontSize="small" />
                                ),
                                Image: <ImageOutlined fontSize="small" />,
                                PDF: <PictureAsPdfOutlined fontSize="small" />
                            }}
                            filterRenderer={Filter}
                            headerRenderer={TableHeader}
                            folderRenderer={TableFolder}
                            fileRenderer={TableFile}
                        />
                        <hr />
                        {!!files.length && <RenderDownloadAll />}
                    </Box>
                )}
            </Paper>
        </>
    );
};
